import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { AuthService } from '../../auth/service/auth.service';
import { TaskDetail, TaskUpdate } from '../model/taskDetail';
import url from 'src/settings.json';
import { Setting } from '../../common/settings';
import { OrganisationService } from '../../organisation/organisation/services/organisation.service';
import { PagedResultTask } from '../model/pagedResultTask';
import { ReviewerStatus } from '../model/reviewerStatus';

@Injectable({
  providedIn: 'root'
})
export class TaskService {
  readonly ContentType = 'application/json';
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': this.ContentType,
      //Authorization: 'my-auth-token'
    }),
    params: new HttpParams()
  };
  public countEmitter = new BehaviorSubject<number>(-1);
  organisationSubscriber: Subscription;
  setting: Setting = url;
  currentOrganisation: any = '';

  constructor(private readonly httpClient: HttpClient,
    private readonly oAuthService: AuthService,
    private readonly organisationService: OrganisationService) {
    this.organisationSubscriber = this.organisationService.organisationEmitter.subscribe({
      next: (value: string) => {
        if (value === '') { this.currentOrganisation = this.organisationService.getLocalStorageItem("CurrentOrganisation") }
        else { this.currentOrganisation = value; } }
    });
  }

  public getPendingTasks(pageSize: number, pageIndex: number): Observable<PagedResultTask> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    const params = new HttpParams().set('length', pageSize).set('start', pageIndex);
    return this.httpClient.get<PagedResultTask>(`${url}/api/tasks/pending`, { headers: headers, params: params })
  }

  public getOpenTasks(pageSize: number, pageIndex: number): Observable<PagedResultTask> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    const params = new HttpParams().set('length', pageSize).set('start', pageIndex);
    return this.httpClient.get<PagedResultTask>(`${url}/api/tasks/open`, { headers: headers, params: params })
  }

  public getAllTasks(pageSize: number, pageIndex: number): Observable<PagedResultTask> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    const params = new HttpParams().set('length', pageSize).set('start', pageIndex);
    return this.httpClient.get<PagedResultTask>(`${url}/api/tasks/all`, { headers: headers, params: params })
  }

  public getTaskDetails(id: number): Observable<TaskDetail> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    this.httpOptions.headers = this.httpOptions.headers.set('Content-Type', this.ContentType).set('Authorization', `Bearer ${token}`)
    return this.httpClient.get<TaskDetail>(`${url}/api/task/details/` + id, this.httpOptions);
  }

  public saveResponse(task: TaskUpdate): Observable<boolean> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    this.httpOptions.headers = this.httpOptions.headers.set('Content-Type', this.ContentType).set('Authorization', `Bearer ${token}`)
    return this.httpClient.post<any>(`${url}/api/task/save/`, task, this.httpOptions);
  }

  public getPendingTasksCount() {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    return this.httpClient.get<number>(`${url}/api/tasks/pendingcount`, { headers: headers })
  }

  public getReviewerStatus(requestId: number, requirementId: number): Observable<any> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    const params = new HttpParams().set('requestId', requestId).set('requirementId', requirementId);
    return this.httpClient.get<ReviewerStatus[]>(`${url}/api/task/reviewerstatus`, { headers: headers, params: params })
  }
  public getCSSColorforTask(approvalStatus: string): string {
    switch (approvalStatus) {
      case "Accepted": return "#5cb85c";
      case "Approved": return "#5cb85c";
      case "Needsmorework": return "#d9534f";
      case "Needs more work": return "#d9534f";
      case "Rejected": return "#d9534f";
      case "CouldNotTest": return "#f0ad4e";
      case "Could Not Test": return "#f0ad4e";
      case "NotRelevant": return "#D0E4B0";
      case "Not Relevant": return "#D0E4B0";
      case "Completed": return "#5bc0de";
      case "Reviewed": return "#5bc0de";
      case "Pending": return "#CCCCCC";
      default: return "#CCCCCC";
    }
  }
}
